import { CircularProgress, styled } from '@mui/material';
import { COLORS } from '../../../theme/color';

export const CustomCircularProgress = styled(CircularProgress)({
  color: COLORS.White
});
